import { AdminStock } from '../model/adminStock';
import { AdminRsysProDay } from '../model/adminRsysProDay';
export class AdminStockBuilder {
    static buildAdminStock(data) {
        const adminStock = new AdminStock();
        adminStock.id = data.id;
        adminStock.name = data.name;
        adminStock.is_active = data.is_active;
        return adminStock;
    }
    static buildAdminRsysProDay(data) {
        const adminRsysProDay = new AdminRsysProDay();
        adminRsysProDay.from_date = data.from_date;
        adminRsysProDay.to_date = data.to_date;
        adminRsysProDay.tariff = data.tariff;
        adminRsysProDay.safe = data.safe;
        adminRsysProDay.capacity = data.capacity;
        adminRsysProDay.cp_mg = data.cp_mg;
        return adminRsysProDay;
    }
}
//# sourceMappingURL=adminStock-builder.js.map